if (!customElements.get('lsg-products-grid')) {
    customElements.define('lsg-products-grid', class LSGProductsGrid extends HTMLElement {
            constructor() {
                super();
                this.selectors = {
                    collections: ".js-lsg-products-grid-filter-collections",
                    collectionsBlocks: ".js-lsg-products-grid-filter-collection",
                    sortBy: ".js-lsg-products-grid-filter-sort-by",
                    products: '.js-lsg-products-grid-filter-product',
                    filterToggle: '.js-lsg-products-grid-filter-btn',
                    filterToggleAll: '.js-lsg-products-grid-filter-btn-all',
                    body: "body",
                    productsGroup:".js-lsg-products-grid-group"
                };
                this.sortBy = this.querySelectorAll(this.selectors.sortBy);
                this.filterToggle = this.querySelectorAll(this.selectors.filterToggle);
                this.filterToggleAll = this.querySelectorAll(this.selectors.filterToggleAll);

                this.body = document.querySelector(this.selectors.body);
                this.collections = document.querySelectorAll(this.selectors.collections);
                this.dataCollections = [];
                this.initCollectionsBlock();
                this.init();
            }

            initCollectionsBlock() {
                this.dataCollections = [];
                this.collectionsBlocks = this.querySelectorAll(this.selectors.collectionsBlocks);
                this.collectionsBlocks.forEach((collection) => {
                    let data = [];
                    collection.querySelectorAll(this.selectors.products).forEach((el) => {
                        data.push({
                            element: el,
                            created: Number(new Date(el.getAttribute('data-created'))),
                            price: parseInt(el.getAttribute('data-price'), 10),
                            title: el.getAttribute('data-title'),
                            index: parseInt(el.getAttribute('data-index'), 10),
                            collections: el.getAttribute('data-collections').split(',')
                        })
                    });

                    this.dataCollections.push({
                        collection: collection,
                        products: data
                    });
                });
            }


            sortProducts(sortValue) {
                console.log(this.dataCollections)
                this.dataCollections.forEach((colEl) => {
                    let newProducts = [...colEl.products];
                    switch (sortValue) {
                        case 'manual':
                            newProducts.sort((a, b) => (a.index > b.index ? 1 : -1));
                            break;
                        case 'created-descending':
                            newProducts.sort((a, b) => (b.created > a.created ? 1 : -1));
                            break;
                        case 'price-ascending':
                            newProducts.sort((a, b) => (a.price > b.price ? 1 : -1));
                            break;
                        case 'price-descending':
                            newProducts.sort((a, b) => (b.price > a.price ? 1 : -1));
                            break;
                        case 'title-ascending':
                            newProducts.sort((a, b) => (a.title > b.title ? 1 : -1));
                            break;
                        case 'title-descending':
                            newProducts.sort((a, b) => (b.title > a.title ? 1 : -1));
                            break;
                        default:
                    }
                    let index = 1;
                    const grid = colEl.collection;
                    grid.innerHTML = '';

                    newProducts.forEach((product) => {
                        grid.append(product.element);
                    });

                });

            }

            filterProducts(el) {
                this.filterToggle.forEach(item => {
                    item.classList.remove('is-active')
                });
                this.filterToggleAll.forEach(item => {
                    item.classList.remove('is-active')
                });
                el.classList.add('is-active');
                const handle = el.getAttribute('data-handle');

                let newProducts = this.querySelectorAll(this.selectors.products);

                newProducts.forEach((product) => {
                    const collections = product.getAttribute('data-collections').split(',')
                    if (collections.includes(handle)) {
                        product.classList.remove('is-hidden')
                    } else {
                        product.classList.add('is-hidden');
                    }
                });

                let newProductsGroup = this.querySelectorAll(this.selectors.productsGroup);

                newProductsGroup.forEach((product) => {
                    const collections = product.getAttribute('data-collections').split(',')
                    if (collections.includes(handle)) {
                        product.classList.remove('is-hidden')
                    } else {
                        product.classList.add('is-hidden');
                    }
                });

            }


            init() {
                this.sortBy.forEach(el => {
                    el.addEventListener('change', (event) => {
                        const sortValue = el.value;
                        this.sortProducts(sortValue);

                        el.style.width = 'fit-content';
                    });
                });
                this.filterToggle.forEach(el => {
                    el.addEventListener('click', (event) => {
                        this.filterProducts(el);
                    });
                });
                this.filterToggleAll.forEach(el => {
                    el.addEventListener('click', (event) => {
                        this.filterProducts(el);
                    });
                })
            }
        }
    )
}

